export default {
  init() {
    // JavaScript to be fired on all pages
    $('.text-content a').attr('target', '_blank');
    
    // sliders
    $('.header_slider').each(function(){
      $( this ).slick({
        lazyLoad: 'progressive',
        autoplay: true,
        pauseOnHover: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        speed: 3500,
        fade: true,
        arrows: true
      });
    });

     // 
     document.addEventListener("DOMContentLoaded", function(event) {

       var menu_icons = document.getElementById("menu_icons");
       menu_icons.scrollLeft = 150; 
     });

    $('.thumbnail_slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.segment_slider_js',
      dots: false,
      centerMode: true,
      focusOnSelect: true
    });

      // product filter
      $( '.sidebar-filters .searchandfilter h4' ).on( 'click', function(){
          $( this ).toggleClass( 'active' );
          $( this ).parent().children( 'ul' ).stop().slideToggle(400);
      });

      // hide empty filters
      $( '.sidebar-filters .searchandfilter ul li' ).each( function(){
        var $this = $( this );

        //console.log( $( this ).find( 'ul li' ).length + " counter." );

        if( $( this ).find( 'ul li' ).length >= 1 ){
          $( this ).find( 'h4' ).show();
          
          if($(this).find('input').is(':checked')) {
            $( this ).addClass( 'filter_sub_tonen' );
          }
        }
      });

          // Initialize Fancybox
      $('[data-fancybox], .fancybox').fancybox({
        // Fancybox options
      });

  },
  finalize() {

    // effects
    AOS.init();

    // tooltip
    $('[data-toggle="tooltip"]').tooltip()

    // scrolldown
     // header change on scroll
     $(window).scroll(function(){
      var sticky = $('body'),
          scroll = $(window).scrollTop();
    
      if (scroll >= 32){
        sticky.addClass('scrolldown');
      }else{
        sticky.removeClass('scrolldown');
      }
    });

    // hamburger menu
    // menu toggle mobile 
    $('.icon_burger').on( 'click', function() {
      $('.top-menu').toggleClass('top-animate');
      $('.mid-menu').toggleClass('mid-animate');
      $('.bottom-menu').toggleClass('bottom-animate');

      $('.nav-primary').toggleClass('active-menu');
      
      $('body').toggleClass('noscroll');
    });

    $('.menu-item-has-children .svg-inline--fa').on( 'click', function() {
      
      $( this ).parent().find( '.sub-menu' ).toggleClass( 'active-sub-menu' );

    });

    $( '.icon_menu_open' ).on( 'click', function(){

      $('.nav-primary').toggleClass('active-menu');
      
      $('body').toggleClass('noscroll');
    });


  // search modal
  $( '.modal' ).on('shown.bs.modal', function() {
    // focus on searchField
    $( '#search_products' ).focus();
  });

  $( '.close' ).on('click', function() {
    // focus on searchField
    $( '#search_products' ).val( '' );
    $( '.search__results' ).html( '' );
    $( '.modal .close' ).removeClass( 'icon_close' );
  });

  // Search Section
  $( '.icon_zoeken' ).on('click', function(event){

    var typingTimer;

    event.preventDefault();

    //start search query after user is done typing
    $( '#search_products' ).keyup(function(){

      var keyword = $( this ).val();

      clearTimeout( typingTimer );

      if (keyword) {
        $( '.modal .close' ).addClass( 'icon_close' );

        typingTimer = setTimeout(function() { startSearching( keyword );	}, 200);
        
      }else{

        $( '.modal .close' ).removeClass( 'icon_close' );

        $( '.search__results' ).html( '' );
      }
    });
  });

  function startSearching ( inputvalue ) {

    // show loader
    $( '.search__results_holder' ).show();
    $( '.search__results .zoeken_placeholder' ).show();

    if(inputvalue.length > 2){

      $.ajax({
        url  : search.ajaxurl,
        type : 'get',
        data : {
          action 			: 'paginas_gaan_zoeken',
          query			  : inputvalue,
          security		: search.ajax_nonce,
        },
        success : function( response ) {

          // search results
          $( '.search__results' ).html(response);
        },
        error: function (textStatus, errorThrown) {

          console.log('Er ging iets fout' + errorThrown + textStatus);
        },
      });
    }
  }
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js